<!--
 * @Author: 范向玲
 * @Date: 2022-11-10 11:04:08
 * @LastEditTime: 2024-12-27 15:42:42
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 走势库数据管理--查询条件
 * @FilePath: \web\src\components\ProjectPerformance\DataManager\search.vue
-->
<template>
  <section class="trend-search">
    <section class="search-item">
      <a-select class="mine-select" placeholder="矿种" v-model:value="requestParams.commodity"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option v-for="item in minerals" :key="item.name">
          {{ item.name }}
        </a-select-option>
        <template #suffixIcon>
          <CaretDownOutlined />
        </template>
      </a-select>
    </section>
    <section class="search-item">
      <a-input placeholder="指标名称" v-model:value="requestParams.keyword" />
    </section>
    <section class="search-item">
      <a-input placeholder="数据来源" v-model:value="requestParams.source" />
    </section>
    <!-- <section class="search-item" style="width: 3.2rem">
      <div class="search-item-text">时间区间：</div>
      <a-range-picker v-model:value="timeRange" />
    </section> -->
    <!-- <div class="search-item">
      <a-input
        placeholder="请输入搜索关键词"
        style="width: 3.5rem"
        v-model:value="requestParams.keyword"
      />
    </div> -->
    <slot name="trendBtns">
      <div class="btn-wrapper">
        <div class="reset-btn btn-item" @click="resetSearch">重置</div>
        <div class="search-btn btn-item" @click="submitSearch()">查询</div>
      </div>
    </slot>
  </section>
</template>

<script setup>
import { ref, reactive, computed, toRefs, watch, onMounted, defineProps, defineEmits, } from 'vue';
import { CaretDownOutlined, } from '@ant-design/icons-vue';
import { useStore, } from 'vuex';
import moment from 'moment';

const props = defineProps({
  storeModule: {
    type: String,
    default: 'trendDataManager',
  },
});

const timeRange = ref([]);

const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();

const generalState = computed(() => state.general);
const { minerals, } = toRefs(generalState.value);

const trendDataManagerState = computed(() => state.trendDataManager);
const { requestParams, } = toRefs(trendDataManagerState.value);
const emit = defineEmits(['submit',]);
const { storeModule, } = toRefs(props);


// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || storeModule.value}/${methods}`, params);

/**
 * @description 查询
 */
const submitSearch = async () => {
  // let time = timeRange.value;

  // if (time.length > 0) {
  //   await commit(null, 'setRequestParams', { startTime: moment(time[0]).format('YYYY-MM-DD'), endTime: moment(time[1]).format('YYYY-MM-DD'), });
  // }
  commit(null, 'setRequestParams', { page: 1, size: 10, });
  await emit('submit');
};

/**
 * @description 重置
 */
const resetSearch = async () => {
  timeRange.value = [];
  await commit(null, 'clear');
  await emit('submit');
};


</script>

<style lang='scss'>
.trend-search {
  display: flex;

  .search-item {
    width: 1.8rem;
    height: 0.34rem;
    margin-right: 0.05rem;
    display: flex;

    .search-item-text {
      color: #fff;
      width: 1.1rem;
      text-align: right;
      height: 0.34rem;
      line-height: 0.34rem;
    }
  }

  /* 输入框 */
  .ant-input {
    color: white;
    background-color: rgba(91, 76, 39, 0.4);
    font-size: 0.14rem;
    font-family: Microsoft YaHei;
    border: transparent;
  }

  .ant-input-suffix {
    width: 0.12rem;
    height: 0.12rem;
    margin-top: .02rem;
  }

  /** 下拉框 */
  .ant-select {
    width: 100%;
    height: 100%;

    .ant-select-selector {
      height: 100%;
    }

    .ant-select-arrow {
      color: #fff;
    }

    .ant-select-selection-item {
      line-height: .34rem;
    }

    // 背景
    &:not(.ant-select-customize-input) .ant-select-selector {
      background-color: rgba(91, 76, 39, 0.4);
      border: none;
      color: #fff;
    }

    /* 描述 */
    .ant-select-selection-placeholder {
      line-height: .34rem;
      color: #fff;
      padding-right: 0;
    }
  }

  /* 输入框 */
  .ant-input {
    color: white;
    background-color: rgba(91, 76, 39, 0.4);
    font-size: 0.14rem;
    font-family: Microsoft YaHei;
    border: transparent;
    padding-top: 0rem;
    padding-bottom: 0rem;
    height: 100%;
  }

  .ant-input-suffix {
    width: 0.12rem;
    height: 0.12rem;
    margin-top: .02rem;
  }

  .btn-wrapper {
    height: 0.32rem;
    line-height: 0.32rem;
    margin-left: 0.2rem;
    color: #ffffff;
    display: flex;
    padding: 0;

    .btn-item {
      width: 0.9rem;
      text-align: center;
      cursor: pointer;

      &:active {
        opacity: 0.8;
      }
    }

    .reset-btn {
      // background-color: #535962;
      background-image: url(~@/static/images/dataManagement/reset_btn.png);
      background-size: 100% 100%;
      margin-right: 0.05rem;
    }

    .search-btn {
      // background-color: #efb227;
      background-image: url(~@/static/images/dataManagement/submit_btn.png);
      background-size: 100% 100%;
    }
  }
}
</style>